/* @flow */

import * as React from 'react'
import { SplitComponent, SessionContext } from '../shared'

const Dashboard = React.lazy(() => import('./Dashboard'))
const DashboardV2 = React.lazy(() => import('./DashboardV2'))

type Props = Object

const Wrapper = (props: Props) => {
  const { entity } = React.useContext(SessionContext)

  return (
    <SplitComponent
      entity
      false={Dashboard}
      splitKey="dashboard_v2"
      true={DashboardV2}
      {...props}
    />
  )
}

export default Wrapper
